export const EVENT_TYPES = {
  GENERAL_ADMISSION: 'GENERAL_ADMISSION',
  TIMED_TICKETING: 'TIMED_TICKETING',
} as const

export type EventType = (typeof EVENT_TYPES)[keyof typeof EVENT_TYPES]

export const TICKET_STATUS = {
  AVAILABLE: 'available',
  LIMITED: 'limited',
  SOLD_OUT: 'sold_out',
} as const

export type TicketStatus = (typeof TICKET_STATUS)[keyof typeof TICKET_STATUS]

export const ORDER_STATUS = {
  PENDING: 'pending',
  PROCESSING: 'processing',
  COMPLETED: 'completed',
  FAILED: 'failed',
} as const

export type OrderStatus = (typeof ORDER_STATUS)[keyof typeof ORDER_STATUS]

export const PAYMENT_METHODS = {
  STRIPE: 'stripe',
  SQUARE: 'square',
  CASH: 'cash',
  CHECK: 'check',
} as const

export type PaymentMethod = (typeof PAYMENT_METHODS)[keyof typeof PAYMENT_METHODS]
